export default __webpack_public_path__ + "static/banner-four-shape4-32b9478647b2c4d5731a3a91423cc34c.png";